__webpack_require__.p = "/MINIBLOG/";